/* Maqas · product page helpers: selected value in the option label, size guide next to the size label,
   price inside the add-to-cart button. Lessons from DA (Yawmi). */
(function () {
  var d = document;
  function ar() { return (d.documentElement.lang || '').toLowerCase().indexOf('ar') === 0; }
  function legends() {
    d.querySelectorAll('.variant-option--buttons:not(.variant-option--swatches)').forEach(function (fs) {
      var lg = fs.querySelector('legend'); if (!lg) return;
      var v = fs.querySelector('input:checked');
      var sp = lg.querySelector('.mq-legend__val');
      if (!sp) { sp = d.createElement('span'); sp.className = 'mq-legend__val'; lg.appendChild(sp); }
      var txt = v ? v.value : '';
      if (sp.textContent !== txt) { sp.innerHTML = ''; if (txt) { var bd = d.createElement('bdi'); bd.textContent = txt; sp.appendChild(bd); } }
      if (ar()) {
        var tn = [].slice.call(lg.childNodes).find(function (n) { return n.nodeType === 3 && n.textContent.trim(); });
        if (tn) { var k = tn.textContent.trim().toLowerCase(); var m = { size: 'المقاس', color: 'اللون', colour: 'اللون' }[k]; if (m) tn.textContent = m; }
      }
    });
  }
  var guideLink = null;
  function placeGuide() {
    var sg = d.querySelector('[data-mq-sg]');
    if (sg && !sg.hasAttribute('data-placed')) {
      guideLink = sg.querySelector('[data-mq-sg-open]');
      var dlg = sg.querySelector('[data-mq-sg-dlg]'); if (dlg) d.body.appendChild(dlg);
      sg.setAttribute('data-placed', '1');
      sg.hidden = true;
    }
    if (!guideLink) return;
    var fs = [].slice.call(d.querySelectorAll('.product-details .variant-option--buttons')).find(function (f) {
      var n = (f.querySelector('legend') || {}).textContent || '';
      return /size|مقاس|قياس/i.test(n);
    });
    if (!fs) return;
    var lg = fs.querySelector('legend');
    if (lg.contains(guideLink)) return;
    lg.classList.add('mq-legend--row');
    lg.appendChild(guideLink);
  }
  function atcPrice() {
    var btn = d.querySelector('.product-form-buttons .add-to-cart-button, .product-form-buttons button[type="submit"]'); if (!btn) return;
    var price = d.querySelector('.product-details .price-item__group.price .price, .product-details .price');
    var txt = price ? price.textContent.replace(/\s+/g, ' ').trim() : '';
    var sp = btn.querySelector('.mq-atc-price');
    if (!txt) { if (sp) sp.remove(); return; }
    if (!sp) { sp = d.createElement('span'); sp.className = 'mq-atc-price'; var c = btn.querySelector('.add-to-cart-text__content') || btn; c.appendChild(sp); }
    if (sp.textContent !== txt) sp.textContent = txt;
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mq-sg-open]');
    if (o) { var dl = d.querySelector('[data-mq-sg-dlg]'); if (dl && dl.showModal) { dl.showModal(); } return; }
    var x = e.target.closest('[data-mq-sg-close]');
    if (x) { x.closest('dialog').close(); return; }
    var dlg = e.target.closest('[data-mq-sg-dlg]');
    if (dlg && e.target === dlg) dlg.close();
  });
  d.addEventListener('change', function (e) { if (e.target.closest('.variant-option')) setTimeout(function () { legends(); atcPrice(); }, 60); });
  function run() { legends(); placeGuide(); atcPrice(); }
  var q = 0;
  new MutationObserver(function () { if (q) return; q = requestAnimationFrame(function () { q = 0; run(); }); }).observe(d.documentElement, { childList: true, subtree: true });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
  d.addEventListener('shopify:section:load', run);
})();
